import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {CentreOption} from "../../../../../interfaces/Centres";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Employee} from "../../../../../interfaces/Employee";
import {InductionService} from "../../induction/induction.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CentreService} from "../../../../../services/centre.service";
import {EmployeeService} from "../../../../../services/employee.service";
import {LogService} from "../../../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {map, takeUntil} from "rxjs/operators";
import {MatSnackBar} from "@angular/material/snack-bar";
import {SpecialDayService} from "../special-day.service";
import {SpecialDay} from "../special-day.model";
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {LoadingService} from "../../../../../services/loading.service";
import firebase from "firebase/compat/app";
import {AddFieldComponent} from "../../../../../components/types/add-field/add-field.component";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-add-edit-special-day',
  templateUrl: './add-edit-special-day.component.html',
  styleUrls: ['./add-edit-special-day.component.scss']
})
export class AddEditSpecialDayComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  allCenters$!: Observable<CentreOption[]>;
  displayCentre = (c: any) => c?.centreName;
  displaySpecialDay = (c: any) => c;
  specialDayForm !: FormGroup;
  observerName: any
  allTeachers: any[]=[]
  employeeData!: Employee[];
  currentEditId:any;
  isLoading: boolean = false;
  selectedCentre:any;
  _specialDay$: Observable<string[]>
  selectedFiles: any;
  data: any; // To store existing record data
  MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB size limit
  // ALLOWED_FILE_TYPES = [
  //   'application/pdf',
  //   'application/msword', // .doc
  //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  //   'application/vnd.ms-powerpoint', // .ppt
  //   'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  //   'text/plain' // .txt
  // ];
  MAX_FILES = 5;

  // add image MIME types
  ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.ms-powerpoint', // .ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'text/plain', // .txt
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/webp',
    'image/svg+xml'
  ];

  @ViewChild('specialDaySearchInput') specialDaySearchInput!: ElementRef;
  selectedSpecialDay: any = null;

  specialDaySearchText: string = '';
  specialDayDebounceTimer: any;
  specialDayList: string[] = []; // store Special Day list
  allSpecialDayTypes: any[] = [];
  filteredSpecialDayTypes: any[] = [];


  constructor(private fb: FormBuilder,
              private specialDayService : SpecialDayService,
              private router: Router,
              private route : ActivatedRoute,
              private centreService : CentreService,
              private userService: EmployeeService,
              private mLogService : LogService,
              private snackBar : MatSnackBar,
              private readonly mDatabase: AngularFireDatabase,
              private storage : AngularFireStorage,
              private loader : LoadingService,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public dialogData: any,
              private dialogRef: MatDialogRef<AddEditSpecialDayComponent>) {
    this.allCenters$ = this.centreService.getAllCentres()
    this._specialDay$ = this.mDatabase.list<string>('types/Special Day').valueChanges();
    this._specialDay$.pipe(takeUntil(this._destroyed$)).subscribe(d => this.specialDayList = d);
  }

  ngOnInit(): void {
    this.formInit();
    this.fetchLeadTeacher();
    this.fetchAllTeachers();
    this.currentEditId = this.route.snapshot.paramMap.get('id');

    if (this.dialogData?.id) {
      this.currentEditId = this.dialogData.id;

      this.specialDayService.getDataById(this.currentEditId).pipe(takeUntil(this._destroyed$)).subscribe((record: any) => {
        if (record) {
          this.data = { ...record, id: this.currentEditId };
          this.patchForm(record);
        }
      });

    }
  }

  // patchForm(record: any) {
  //   this.specialDayForm.patchValue({
  //     date: record.date?.toDate(),
  //     teacherName: record.teacherName,
  //     centreName: record.centreName,
  //     centreCode: record.centreCode,
  //     specialDay: record.specialDay,
  //     fileUrls: record.fileUrls || []
  //   });
  //
  //   this.selectedCentre = {
  //     centreName: record.centreName,
  //     centreCode: record.centreCode
  //   };
  // }

  patchForm(record: any) {
    this.specialDayForm.patchValue({
      date: record.date?.toDate(),
      teacherName: record.teacherName,
      centreName: record.centreName,
      centreCode: record.centreCode,
      specialDay: record.specialDay,
      fileUrls: record.fileUrls || []
    });

    this.selectedCentre = {
      centreName: record.centreName,
      centreCode: record.centreCode
    };

    // ✅ Set selected special day for dropdown display
    this.selectedSpecialDay = record.specialDay;
  }


  formInit() {
    this.specialDayForm = this.fb.group({
      date: ['', Validators.required],
      teacherName: ['', Validators.required],
      centreName: ['', Validators.required],
      centreCode: ['', Validators.required],
      specialDay: ['', Validators.required],
      fileUrls: [[]],
    });
  }

  get specialDay() {
    return this.specialDayForm.get('specialDay');
  }

  async submitForm() {
    if (this.specialDayForm.invalid) return;

    this.isLoading = true;
    this.loader.setLoading(true);

    // Get Logged user
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const username = `${userData.userName || ''}`.trim() || 'Unknown User';

    const payload: any = {
      date: new Date(this.specialDayForm.value.date),
      teacherName: this.specialDayForm.value.teacherName,
      centreName: this.specialDayForm.value.centreName,
      centreCode: this.specialDayForm.value.centreCode,
      specialDay: this.specialDayForm.value.specialDay,
      fileUrls: [...this.data?.fileUrls || []]
    };

    try {
      // ------------ FILE UPLOAD ------------
      if (this.selectedFiles?.length) {
        const fileUrls: string[] = [];

        if (this.currentEditId) {
          // Editing → store inside existing ID folder
          for (let file of this.selectedFiles) {
            const filePath = `specialDayFiles/${this.currentEditId}/${file.name}`;
            const fileRef = this.storage.ref(filePath);
            await fileRef.put(file);
            const downloadURL = await fileRef.getDownloadURL().toPromise();
            fileUrls.push(downloadURL);
          }
        } else {
          // Creating → store using timestamp
          const timestamp = Date.now();
          for (let file of this.selectedFiles) {
            const filePath = `specialDayFiles/${timestamp}/${file.name}`;
            const fileRef = this.storage.ref(filePath);
            await fileRef.put(file);
            const downloadURL = await fileRef.getDownloadURL().toPromise();
            fileUrls.push(downloadURL);
          }
        }

        payload.fileUrls = [...payload.fileUrls, ...fileUrls];
      }

      // ------------ UPDATE LOGIC ------------
      if (this.currentEditId) {

        payload.updatedBy = username;
        payload.updatedAt = firebase.firestore.FieldValue.serverTimestamp();

        await this.specialDayService.update(this.currentEditId, payload);

        this.mLogService.addLog({
          date: Date.now(),
          section: 'Special Day',
          action: 'Updated',
          description: `${username} updated Special Day record`,
          currentIp: localStorage.getItem('currentip') || ''
        });

        this.afterSave('Updated successfully!');

      } else {
        // ------------ CREATE LOGIC ------------

        payload.createdBy = username;
        payload.createdAt = firebase.firestore.FieldValue.serverTimestamp();
        payload.status = "Active";

        await this.specialDayService.create(payload);

        this.mLogService.addLog({
          date: Date.now(),
          section: 'Special Day',
          action: 'Created',
          description: `${username} created a new Special Day record`,
          currentIp: localStorage.getItem('currentip') || ''
        });

        this.afterSave('Saved successfully!');
      }

      // Always redirect after save/update
      this.dialogRef.close(); // important

      setTimeout(() => {
        this.router.navigate(['/home/education/special-day-list']);
      }, 100);


    } catch (error) {
      console.error('Error saving Special Day:', error);
      this.isLoading = false;
      this.loader.setLoading(false);
      this.showSnackbar('Failed to save Special Day.', 'Close', 'error');
    }
  }


  private afterSave(message: string) {
    this.isLoading = false;
    this.loader.setLoading(false);
    this.showSnackbar(message, 'Close', 'success');
    // this.router.navigate(['/home/education/special-day-list']);
    this.specialDayForm.reset();
    this.currentEditId = null;
    this.selectedFiles = null;
  }

  fetchLeadTeacher() {
    this.userService.getUsers().pipe(takeUntil(this._destroyed$)).subscribe(snapshotchanges => {
      this.employeeData = snapshotchanges.map(w => {
        let emp = w.payload.toJSON() as Employee;
        if (w.key != null) {
          emp['id'] = w.key;
        }
        return emp;
      });
      const namesToRemove = ['Shilpa Pahuja', 'Mukti Panchamia'];
      this.observerName = this.employeeData
        .filter(employee => employee?.jobtitle === 'Lead Teacher' && employee.disabled !== true)
        .map(counsellingEmployee => ({ name: counsellingEmployee?.userName }))
        .filter(c => !namesToRemove.includes(c?.name))
        .sort((a, b) => a?.name.localeCompare(b?.name));
    });
  }

  fetchAllTeachers() {
    this.userService.getUsers().pipe(takeUntil(this._destroyed$)).subscribe(snapshotchanges => {
      this.employeeData = snapshotchanges.map(w => {
        let emp = w.payload.toJSON() as Employee;
        if (w.key != null) {
          emp['id'] = w.key;
        }
        return emp;
      });
      const namesToRemove = ['Shilpa Pahuja', 'Mukti Panchamia'];
      this.allTeachers = this.employeeData
        .filter(employee => (employee?.role === 'Teacher' || employee?.role === 'Sr Teacher') && employee.disabled !== true)
        .map(counsellingEmployee => ({ name: counsellingEmployee?.userName }))
        .filter(c => !namesToRemove.includes(c?.name))
        .sort((a, b) => a?.name.localeCompare(b?.name));
    });
  }

  resetForm() {
    this.specialDayForm.reset();
    this.currentEditId = null;
    this.selectedFiles = null;
  }

  onCancel() {
    // this.router.navigate(['/home/education/special-day-list']);

    this.dialogRef.close();
  }

  get suggestionsLength(): number {
    const val: string = this.specialDayForm.get('suggestions')?.value || '';
    return val.length;
  }

  onTeacherSelected(selected: any) {
    console.log('Selected Teacher:', selected);
    this.specialDayForm.get('teacherName')?.setValue(selected.name);
  }


  onSelectionSpecialDay(e:any){
    this.specialDayForm.patchValue({
      specialDay: e,
    })
  }

  onCentreSelect($event: any) {
    console.log($event);

    // Check if the selection is valid
    if ($event && $event.centreName && $event.centreCode) {
      this.specialDayForm.patchValue({
        centreName: $event.centreName,
        centreCode: $event.centreCode
      });

      // Clear any previous errors
      this.specialDayForm.get('centreName')?.setErrors(null);
      this.specialDayForm.get('centreCode')?.setErrors(null);
    } else {
      // If invalid selection, clear the values and set error
      this.specialDayForm.patchValue({
        centreName: '',
        centreCode: ''
      });

      this.specialDayForm.get('centreName')?.setErrors({ invalidSelection: true });
      this.specialDayForm.get('centreCode')?.setErrors({ invalidSelection: true });
    }
  }



  onSelectProductType(event: any) {
    const selectedType = event.value;
    this.specialDayForm.patchValue({
      specialDay: selectedType,
    });
  }




// ...

  onFileChange(event: any): void {
    const files = event.target.files;

    if (!files || files.length === 0) {
      return;
    }

    let existingCount = this.data?.fileUrls?.length || 0;
    let newCount = files.length;

    // ------ CHECK MAX 5 FILE LIMIT ------
    if (existingCount + newCount > this.MAX_FILES) {
      this.specialDayForm.get('fileUrls')?.setErrors({
        invalidFile: true,
        message: `You cannot upload more than ${this.MAX_FILES} files.`
      });

      this.showSnackbar(`You cannot upload more than ${this.MAX_FILES} files.`, 'Close', 'error');
      event.target.value = ''; // reset input
      this.selectedFiles = null;
      return;
    }

    // -------- FILE TYPE & SIZE VALIDATION --------
    let isValid = true;
    let errorMessage = '';

    for (let i = 0; i < files.length; i++) {
      const file: File = files[i];

      // Check file size
      if (file.size > this.MAX_FILE_SIZE) {
        isValid = false;
        errorMessage = `File "${file.name}" exceeds 25MB size limit.`;
        break;
      }

      // Check file type
      // Allow known document types OR any image/* MIME type
      const isAllowedType =
        this.ALLOWED_FILE_TYPES.includes(file.type) ||
        (file.type && file.type.startsWith('image/'));

      if (!isAllowedType) {
        isValid = false;
        errorMessage = `File "${file.name}" has an invalid type. Only images and documents are allowed.`;
        break;
      }
    }

    if (!isValid) {
      this.specialDayForm.get('fileUrls')?.setErrors({
        invalidFile: true,
        message: errorMessage
      });
      this.showSnackbar(errorMessage, 'Close', 'error');
      this.selectedFiles = null;
      event.target.value = '';
    } else {
      this.specialDayForm.get('fileUrls')?.setErrors(null);
      this.selectedFiles = files;
    }
  }



  // onFileChange(event: any): void {
  //   const files = event.target.files;
  //
  //   if (!files || files.length === 0) {
  //     return;
  //   }
  //
  //   // Validate each file
  //   let isValid = true;
  //   let errorMessage = '';
  //
  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];
  //
  //     // Check file size
  //     if (file.size > this.MAX_FILE_SIZE) {
  //       isValid = false;
  //       errorMessage = `File "${file.name}" exceeds 25MB size limit.`;
  //       break;
  //     }
  //
  //     // Check file type
  //     if (!this.ALLOWED_FILE_TYPES.includes(file.type)) {
  //       isValid = false;
  //       errorMessage = `File "${file.name}" has an invalid type. Only documents are allowed (no ZIP files).`;
  //       break;
  //     }
  //   }
  //
  //   if (!isValid) {
  //     // Set validation error on the form control
  //     this.specialDayForm.get('fileUrls')?.setErrors({
  //       invalidFile: true,
  //       message: errorMessage
  //     });
  //     this.showSnackbar(errorMessage, 'Close', 'error');
  //     this.selectedFiles = null;
  //     event.target.value = ''; // Clear the file input
  //   } else {
  //     // Clear any previous errors
  //     this.specialDayForm.get('fileUrls')?.setErrors(null);
  //     this.selectedFiles = files;
  //   }
  // }

  showSnackbar(message: string, action: string, type: 'success' | 'error' = 'success') {
    this.snackBar.open(message, action, {
      duration: 3000,
      panelClass: type === 'success' ? 'snackbar-success' : 'snackbar-error'
    });
  }

  removeFile(index: number): void {
    if (this.data?.fileUrls) {
      this.data.fileUrls.splice(index, 1);

      this.specialDayForm.patchValue({
        fileUrls: this.data.fileUrls
      });

      // Re-enable file input
      this.specialDayForm.get('fileUrls')?.setErrors(null);
    }
  }

  onSpecialDayOpened(isOpened: boolean) {
    if (isOpened) {
      setTimeout(() => {
        this.specialDaySearchInput?.nativeElement.focus();
      }, 0);
    }
  }

  onSpecialDaySearch(event: any) {
    clearTimeout(this.specialDayDebounceTimer);

    this.specialDayDebounceTimer = setTimeout(() => {
      this.specialDaySearchText = event.target.value.toLowerCase();
    }, 300);
  }

  get filteredSpecialDays() {
    if (!this.specialDayList) return [];

    const sorted = [...this.specialDayList].sort((a, b) =>
      a.trim().toLowerCase().localeCompare(b.trim().toLowerCase())
    );

    if (!this.specialDaySearchText) return sorted;

    return sorted.filter(day =>
      day.toLowerCase().includes(this.specialDaySearchText)
    );
  }

  onAddTypeClick(event: MouseEvent): void {
    event.stopPropagation(); // prevent dropdown from toggling
    this.openAddTypeDialog(); //  open popup only
  }
  handleAdd(event: any) {
    console.log("Add button clicked in child:", event);
    this.openAddTypeDialog(); //
  }


  openAddTypeDialog(): void {
    const dialogRef = this.dialog.open(AddFieldComponent, {
      width: '400px',
      disableClose: true,
      data: 'Special Day'  // ✅ Pass type name to popup
    });

    dialogRef.afterClosed().pipe(takeUntil(this._destroyed$)).subscribe(() => {
      // ✅ Real-time sync — no manual reload needed
      this.mDatabase.list('types/Special Day').valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(types => {
        this.allSpecialDayTypes = types;
        this.filteredSpecialDayTypes = [...types];
      });
    });
  }

  extractFileName(url?: string): string {
    if (!url) return '';
    const decoded = decodeURIComponent(url);
    const lastPart = decoded.split('/').pop() || "";
    return lastPart.split('?')[0];
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
